// extracted by mini-css-extract-plugin
export var mt0 = "fp-tC";
export var mt1 = "fp-uC";
export var mt2 = "fp-vC";
export var mt3 = "fp-wC";
export var mt4 = "fp-xC";
export var mt5 = "fp-yC";
export var mt6 = "fp-zC";
export var widgetForm = "fp-AC";
export var widgetForm__body = "fp-DC";
export var widgetForm__form = "fp-EC";
export var widgetForm__headline = "fp-CC";
export var widgetForm__img = "fp-BC";